import { type FunctionComponent } from "react";
import { CheckOutlined, DeleteOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Popover, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { type ScheduledFitnessAppAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";
import { ProgramAutomationTaskStatus } from "@fitness-app/data-models/entities/ProgramAutomation";

import { getMinutesWithLeadingZero } from "~/modules/Automation/utils/getMinutesWithLeadingZero";

interface OwnProps {
  item: ScheduledFitnessAppAutomation;
  onRemove: () => void;
  status?: ProgramAutomationTaskStatus;
}

type Props = OwnProps;

const FitnessAppTaskItem: FunctionComponent<Props> = ({ item, onRemove, status }) => {
  const { t } = useTranslation(["automation", "common"]);
  const minutesWithLeadingZero = getMinutesWithLeadingZero(item.sentTime.minutes);

  return (
    <Popover
      title={t("automation:programAutomation.tagsAction")}
      content={
        <Space direction="vertical">
          <Space>
            <Typography.Text type="secondary">{t("common:taskType")}:</Typography.Text>
            <Typography.Text>{t(`common:fitnessAppTask.${item.action.type}`)}</Typography.Text>
          </Space>
          <Space>
            <Typography.Text type="secondary">{t("common:tags")}:</Typography.Text>
            <Typography.Text>{item.action.tags.join(", ")}</Typography.Text>
          </Space>
          <Space>
            <Typography.Text type="secondary">{t("automation:programAutomation.operationTime")}:</Typography.Text>
            <Typography.Text>
              {item.sentTime.hours}:{minutesWithLeadingZero}
            </Typography.Text>
          </Space>
          <Button danger icon={<DeleteOutlined />} type="text" onClick={onRemove} />
        </Space>
      }
    >
      <UserOutlined className="mr-2" />
      <span>
        {item.sentTime.hours}:{minutesWithLeadingZero}
      </span>

      {status === ProgramAutomationTaskStatus.Done && <CheckOutlined className="ml-2 text-green-500" />}
    </Popover>
  );
};

export default FitnessAppTaskItem;
